module.exports = __webpack_public_path__ + "fonts/fa-light-300.5ce1b436.woff";